import { Button, Flex, Spin, Typography } from 'antd';
import { useState } from 'react';
import { generatePath, Link, useParams } from 'react-router-dom';

import { ROUTES_PATH } from '@/constants/routes.constants';
import { AccountTable } from '@/features/account/components/account-table';
import {
  useDeleteAccount,
  useResendInvitationMail,
} from '@/features/account/mutations';
import { useUserInformation } from '@/hooks/use-user-information';

import { useOrganizationAccounts } from '../queries/accounts';

interface OrganizationAccountsProps {
  activeKey: string;
  isWeddingChain?: boolean;
  loginAccountId?: number;
}

export function OrganizationAccounts({
  activeKey,
  isWeddingChain,
  loginAccountId,
}: Readonly<OrganizationAccountsProps>) {
  const { id } = useParams();
  const { organizationId } = useUserInformation();
  const [currentPage, setCurrentPage] = useState(1);
  const currentOrganizationId = id ?? organizationId!;

  const { data, isLoading, isFetching, refetch } = useOrganizationAccounts(
    currentOrganizationId,
    { page: currentPage },
    { enabled: activeKey === 'accounts' },
  );

  const { mutate: deleteAccount } = useDeleteAccount({
    onSuccess: () => refetch(),
  });
  const { mutate: resendInvitationMail } = useResendInvitationMail({
    onSuccess: () => refetch(),
  });

  if (isLoading) return <Spin size="small" />;

  return (
    <>
      <Flex justify="space-between" align="center" className="mb-16">
        <Typography.Text className="text-md" type="secondary">
          全{data?.total_records}件
        </Typography.Text>
        <Link
          to={
            id
              ? generatePath(ROUTES_PATH.organizationAccountsNew, { id })
              : ROUTES_PATH.myOrganizationAccountsNew
          }
        >
          <Button type="primary">アカウント登録</Button>
        </Link>
      </Flex>
      <AccountTable
        isOrganizationAccount
        isWeddingChain={isWeddingChain}
        loginAccountId={loginAccountId}
        dataSource={data?.accounts}
        loading={isFetching}
        deleteAccount={deleteAccount}
        resendInvitationMail={resendInvitationMail}
        pagination={{
          total: data?.total_records,
          onChange(page) {
            setCurrentPage(page);
          },
        }}
      />
    </>
  );
}
